import * as _ from 'underscore';
import * as ng from 'angular';

import { Experience, ExperienceTypeDef } from '../../';
import { EditorModel } from '../../editor/editor.model';
import { EditorPageModel } from '../../editor/editor-page.model';
import { L10nService } from '../../../../shared';
import { GuestType, GuestTypeService } from '../../../guest-type';

const settingsViewUrl = require('./qrcode-settings.html');

ng.module('e360')
   .factory('qrcodeEditorModelFactory', qrcodeEditorModelFactory);

qrcodeEditorModelFactory.$inject = ['instanceServiceFactory'];
function qrcodeEditorModelFactory(instanceServiceFactory) {
   return instanceServiceFactory(QRCodeEditorModel);
}

export interface QRCodeEditorModelFactory {
   ({campaign, typeDef:ExperienceTypeDef, experience:Experience}):QRCodeEditorModel
}

export class QRCodeEditorModel extends EditorModel {
   readonly workspaceClass: string;
   readonly pages: QRCodePageModel[];
   readonly settingsView: string = settingsViewUrl;
   readonly qrUrl:string;
   private guestTypes:GuestType[];
   templateId:string;

   static $inject = [
      '$http',
      'session',
      'l10n',
      'gettextCatalog',
      'editorCodeParser',
      '$templateCache',
      'GuestTypeService'
   ].concat(['campaign', 'typeDef', 'experience']);

   constructor(
      private $http:ng.IHttpService,
      private session,
      private l10n:L10nService,
      private gettextCatalog,
      private editorCodeParser,
      private $templateCache:ng.ITemplateCacheService,
      private guestTypeService: GuestTypeService,
      campaign, typeDef: ExperienceTypeDef, experience: Experience
   ) {
      super(campaign, typeDef, experience);

      this.gettextCatalog.getString('<p>Scan this pass to check in at the event</p>');
      this.gettextCatalog.getString('<p>Your Event Pass</p>');
      this.gettextCatalog.getString('QR Code Page');

      this.qrUrl = `//${this.session.qrDomain()}`;

      this.hasSettings = true;
      this.hasPreview = true;
      this.workspaceClass = 'qrcode';
      this.previewUrl = `${this.qrUrl}/preview/${this.session.getCampaign().slug}`;

      let brandSettings = this.session.getBrand().settings.experience;
      let defaults = {
         backgroundColor: brandSettings.backgroundColor,
         font: brandSettings.mediaFont,
         fontSize: brandSettings.fontSize,
         fontColor: brandSettings.fontColor,
         footerBackgroundColor: brandSettings.footerBackgroundColor,
         footerFontSize: brandSettings.footerFontSize,
         footerFontColor: brandSettings.footerFontColor,
         footerLinkColor: brandSettings.footerLinkColor,
         footerText: {},
         socialLinkColor: brandSettings.socialLinkColor,
         socialLinkHoverColor: brandSettings.socialLinkHoverColor,
         headerFontSize: brandSettings.headerFontSize,
         linkColor: brandSettings.linkColor,
         mirrorCampaignFooter: true,
         uploads: {
            headerImage: brandSettings.uploads.genericHeader
         },
         guestTypeColor: {}
      };

      if (this.isNew) {
         this.experience = {
            campaignId: campaign.id,
            type: typeDef.id,
            settings: ng.copy(defaults)
         };
      }

      this.l10n.translateObject(
         this.experience.settings,
         'postText',
         '<p>Scan this pass to check in at the event</p>',
         this.languages
      );

      this.l10n.translateObject(
         this.experience.settings,
         'preText',
         '<p>Your Event Pass</p>',
         this.languages
      );

      this.l10n.translateObject(
         this.experience.settings,
         'pageTitle',
         'QR Code Page',
         this.languages
      );

      this.guestTypeService.list(campaign.id).then(guestTypes => {
         this.guestTypes = guestTypes;

         if (!this.experience.settings.guestTypeColor) {
            this.experience.settings.guestTypeColor = {};
         }

         for (let gt of guestTypes) {
            if (!this.experience.settings.guestTypeColor[gt.slug]) {
               this.experience.settings.guestTypeColor[gt.slug] = gt.settings.color;
            }
         }
     });

      this.pages = [new QRCodePageModel(this)];
   }

   init() {
      let url = `${this.qrUrl}/app/qr.view.html`;

      return this.$http.get(url).then(result => {
         let html = [
            '<html>',
            '<head><link rel="stylesheet" href="' + this.qrUrl + '/main.css"></head>',
            '<body>' + result.data + '</body>',
            '</html>'
         ].join('\n');

         return this.editorCodeParser(html, false, this.qrUrl).then(doc => {
            this.templateId = 'qr-editor-view';
            this.$templateCache.put(this.templateId, doc.html);
         });
      })
   }

   onSave() {
      if (this.guestTypes) {
         for (let guestType of this.guestTypes) {
            this.guestTypeService.update(guestType);
         }
      }
   }
}

class QRCodePageModel extends EditorPageModel {
   constructor(editor: QRCodeEditorModel) {
      super(editor);
   }

   get view() {
      return (this.editor as QRCodeEditorModel).templateId;
   }

   get settings() {
      return this.editor.settings;
   }
}
